export { NgxAnimationsModule } from './src/ngx-animations.module';
export * from './src/animations';
export * from './src/directives';



// WEBPACK FOOTER //
// ./libs/ngx-animations/index.ts